import React from 'react';
import { Box } from '@spothero/ui';
import SpotDetailsTransient from 'pages/search-transient-event-monthly/components/spot-details-transient';
import SpotDetailsMonthlyResponsive from 'pages/search-transient-event-monthly/components/spot-details-monthly/SpotDetailsMonthlyResponsive';
import SpotDetailsMonthly from 'pages/search-transient-event-monthly/components/spot-details-monthly/SpotDetailsMonthly';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import useIsMobile from 'hooks/use-is-mobile';
import { SearchPageView } from 'utils/search-page-view';
import { useHideSpotDetails } from '../hooks/use-hide-spot-details/use-hide-spot-details';
export const SpotDetails = () => {
    const isMobile = useIsMobile();
    const onSpotDetailsHidden = useHideSpotDetails();
    const { selectedSpotId: spotId, parkingType, view } = useReduxSearchState();
    const isMonthly = parkingType === 'monthly';
    const MonthlyComponent = isMobile
        ? SpotDetailsMonthlyResponsive
        : SpotDetailsMonthly;
    const SpotDetailsComponent = isMonthly
        ? MonthlyComponent
        : SpotDetailsTransient;
    const onEditTimesModalClose = () => { };
    return (<Box data-testid="SpotDetailsContainer" 
    /**
     * layer 2 avoids clipping of the Search Widget elements
     * layer 5 avoids clipping with map list (this height breaks mobile map so can't be all of it)
     */
    zIndex={view === SearchPageView.MOBILE_MAP ? 'layer5' : 'layer2'} position="relative" sx={{
            '& > .SpotDetails': {
                zIndex: view === SearchPageView.MOBILE_LIST
                    ? 'unset'
                    : 'layer5', // Matching above
                position: { desktop: 'relative' },
                top: {
                    tablet: 'desktop-search-header-height',
                    desktop: 0,
                },
                left: { tablet: 0 },
                height: {
                    tablet: 'desktop-search-body-height',
                },
            },
            '& .SpotDetailsMonthlyResponsive-close': {
                zIndex: 'layer3',
                boxShadow: 'unset',
            },
            '& .SpotDetails-shim.shim.SpotDetails-shim-showing': {
                // To remove at another time
                display: { tablet: 'none' },
            },
            '& .SpotDetails-close-container': {
                width: { tablet: '512px' }, // This is the static width of spot details - to update if we change that
            },
        }}>
            <SpotDetailsComponent isMobile={isMobile} spotId={spotId} onCloseClick={onSpotDetailsHidden} onEditTimesModalClose={onEditTimesModalClose}/>
        </Box>);
};
